/**
 * A validation function that receives a string as parameter and validates if it
 * is a valid email, returning a boolean (true for a valid email and false for an
 * invalid email)
 *
 * @param emailAddress - string
 * @category Validators
 * @category Email
 */
export function isValidEmail(emailAddress: string): boolean {
  const pattern =
    // eslint-disable-next-line
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return pattern.test(emailAddress);
}
